import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';
import { UbicacionesService } from '../../../service/ubicaciones.service';
import { LicitacionService } from '../../../service/licitacion.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-registro',
    templateUrl: './registro.component.html',
    styleUrls: ['./registro.component.css']
})
export class RegistroComponent implements OnInit {
    private subscription: Subscription = new Subscription();
    RouteText: any;
    tituloseo: any;
    urlcanonicaseo: any;
    imagenseo: any;
    keywordsseo: any;
    descripcionseo: any;
    fieldTextType: boolean = false;
    confirma = false;
    success = false;
    error = false;
    estados: any;
    ciudades: any;
    familias: any;
    isLoading: boolean | undefined;
    urlcvEmpresarial!: string;
    urldomicilio!: string;
    urlsituacionFiscal!: string;
    urlestadoCuenta!: string;
    urlRFC!: string;
    urlIne!: string;
    urlImss!: string;
    urlOCumpli !: string;
    urlFoto!: string;

    constructor(
        private meta: Meta,
        private title: Title,
        private _seoService: SeoService,
        private router: Router,
        private _ubicacionesService: UbicacionesService,
        private _urlcanonicaservice: UrlcanonicaService,
        private _licitacionservice: LicitacionService
    ) {

        this.router.events.pipe(filter((event: any) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
            this.RouteText = event;
            this.getSEO(event.url)
        });
    }

    toggleFieldTextType() {
        this.fieldTextType = !this.fieldTextType;
    }

    getSEO(page: string) {
        this._seoService.getSEO(page).subscribe((resp: any) => {
            this.tituloseo = resp.titulo;
            this.descripcionseo = resp.descripcion;
            this.urlcanonicaseo = resp.urlcanonica;
            this.imagenseo = resp.image;

            this._urlcanonicaservice.createCanonicalLink();
            this.title.setTitle(this.tituloseo)
            this.meta.updateTag({name: 'description',content: this.descripcionseo})
            this.meta.updateTag({property: 'twitter:card',content: 'summary'})
            this.meta.updateTag({property: 'twitter:site',content: '@fundacionbest'})
            this.meta.updateTag({property: 'twitter:title',content: 'Fundación BEST'})
            this.meta.updateTag({property: 'twitter:description',content: this.descripcionseo})
            this.meta.updateTag({property: 'twitter:image',content: this.imagenseo})
            this.meta.updateTag({property: 'og:url',content: 'https://fundacionbest.org.mx/licitaciones/registro'})
            this.meta.updateTag({property: 'og:title',content: this.tituloseo})
            this.meta.updateTag({property: 'og:image',content: this.imagenseo})
            this.meta.updateTag({property: 'og:description',content: this.descripcionseo})
        });
    }

    getEstados() {
        this.subscription.add(
            this._ubicacionesService.getEstados().subscribe((resp: any) => {
                this.estados = resp;
            })
        );
    }

    getCiudades(estadoId: number) {
        this.subscription.add(
            this._ubicacionesService.getCiudades(estadoId).subscribe((resp: any) => {
                this.ciudades = resp;
            })
        );
    }

    getFamilias() {
        this.subscription.add(
            this._licitacionservice.getFamiliaIntere().subscribe((resp: any) => {
                this.familias = resp;
            })
        );
    }

    onSubmit(form: NgForm) {
        this.isLoading = true;

        if (form.value.nInterior) { } else { form.value.nInterior = 'S/N' }

        const formulario = {
            Rfc: form.value.rfcescrito,
            Password: form.value.password,
            RazonSocial: form.value.razonSocial,
            Calle: form.value.calle,
            Ninterior: form.value.nInterior,
            Nexterior: form.value.nExterior,
            Colonia: form.value.colonia,
            Referencia: form.value.referencia,
            Idciudad: form.value.ciudadId,
            Idestado: form.value.estadoId,
            Cp: form.value.cp,
            Giro: form.value.giro,
            Nombre: form.value.nombreContacto,
            Paterno: form.value.apellidoPaterno,
            Materno: form.value.apellidoMaterno,
            TelefonoFijo: form.value.telefonoFijo,
            TelefonoMovil: form.value.telefonoMovil,
            Correo: form.value.email,
            UrlCvempresarial: this.urlcvEmpresarial,
            UrlCompDomFiscal: this.urldomicilio,
            UrlEstadoCuenta: this.urlestadoCuenta,
            UrlCompSitFiscal: this.urlsituacionFiscal,
            UrlRfc: this.urlRFC,
            UrlIne: this.urlIne,
            UrlImss: this.urlImss,
            UrlFotoFachada: this.urlFoto,
            UrlOpinionCumplimiento: this.urlOCumpli
        };

        this._licitacionservice.postNewProveedor(formulario).subscribe(resp => {
                
                this.success = true;
            },
            e => {
                console.log(e)
                this.isLoading = false;
            }
        );
    } 

    cvEmpresarialInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlcvEmpresarial = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }
    domicilioFiscalInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urldomicilio = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }
    situacionFiscalInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlsituacionFiscal = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }
    estadoCuentaInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlestadoCuenta = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }
    rfcInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlRFC = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }
    ineInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlIne = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }
    imssInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlImss = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }
    oCumplimientoInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(pdf)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlOCumpli = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }
    fotoInput(event: any) {
        if (event.target.files.length > 0) {
            const file = event.target.files[0];
            if (file.size < 5000000) {
                if (!/(png|jpg|)$/ig.test(file.type)) {
                    alert("Invalid file type: "+file.type+".  Please use DOC, PDF or Zip.");
                }else{
                    this._licitacionservice.UploadImage(file).subscribe((resp: any) => {
                        this.urlFoto = resp.substr(2);
                    });
                }
            } else {
                alert("Invalid file size: "+file.size+".  Please use file to size 5MB");
            }
        }
    }

    cancel() {
        this.confirma = false;
    }
    closeok() {
        this.success = false;
        this.router.navigate(['/licitaciones/login']);
    }
    
    ngOnInit(): void {
        this.getEstados();
    }
}